import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  refresh() {
    // Create a turbo stream refresh and render it
    const refreshStream = document.createElement('turbo-stream')
    refreshStream.setAttribute('action', 'refresh')

    // Render the stream message to trigger a refresh
    Turbo.renderStreamMessage(refreshStream.outerHTML)
  }

  delayRefresh() {
    // Sometimes the refresh happens before the download is complete,
    // so we add a slight delay to ensure the download starts first.
    setTimeout(() => {
      this.refresh()
    }, 500)
  }
}